module.exports = __webpack_public_path__ + "static/Icons_Eye_Large-25163c47ea6dc9027584e27989161f3f.png";